import { Paper, Stack, Text } from '@mantine/core';
import React from 'react';

import { useIssuePage } from '@/contexts';

import styles from './InfluenceTargetPaper.module.css';

type InfluenceTargetPaperProps = {
  title: string;
  subtitle: string;
  onRemove: () => void;
  index: number;
  isOld?: boolean;
};

export const InfluenceTargetPaper: React.FC<InfluenceTargetPaperProps> = ({
  title,
  subtitle,
  onRemove,
  index,
  isOld = false,
}) => {
  const { getIsStaticMode } = useIssuePage();

  return (
    <Paper
      variant="influence_target"
      key={`${isOld ? 'old' : 'new'}-${index}`}
      style={{ position: 'relative' }}
    >
      <Stack gap={0}>
        <Text
          size="md"
          fw={500}
        >
          {subtitle}
        </Text>
        <Text
          size="lg"
          fw={700}
        >
          {title}
        </Text>
      </Stack>
      {!getIsStaticMode() && (
        <span
          className={styles.closeButton}
          onClick={onRemove}
        >
          x
        </span>
      )}
    </Paper>
  );
};

export default InfluenceTargetPaper;
